import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const FavoritesContext = createContext(null);
export const useFavorites = () => useContext(FavoritesContext);

export function FavoritesProvider({ children }) {
  const [ids, setIds] = useState(new Set());

  const load = useCallback(() => {
    api.get("/favorites/ids").then((r) => setIds(new Set(r.data))).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = useCallback(async (id) => {
    const wasFav = ids.has(id);
    setIds((prev) => { const n = new Set(prev); if (n.has(id)) n.delete(id); else n.add(id); return n; });
    try {
      if (wasFav) await api.delete(`/favorites/${id}`);
      else await api.post(`/favorites/${id}`);
    } catch { load(); }
  }, [ids, load]);

  return <FavoritesContext.Provider value={{ ids, toggle, reload: load }}>{children}</FavoritesContext.Provider>;
}
